import {useCallback, useState} from 'react';
import {ChannelPanel} from './channel-panel';
import {PineridgeController} from './controller';
import {DeviceManagementPanel} from './device-management-panel';
import {BUTTON_STYLE_MAIN_FLEX} from './styles';
import {PineridgeChannel} from './pineridge-channel';
import {useEventHandler, emitEvent, Event} from './events';

interface PanelsProps {
  controller: PineridgeController;
}

export function Panels({controller}: PanelsProps) {
  const [channels, setChannels] = useState([...controller.channels]);

  useEventHandler(
    Event.PINERIDGE_CHANNEL_ADDED,
    (channel: PineridgeChannel) => {
      setChannels([...channels, channel]);
    },
    [channels]
  );

  useEventHandler(
    Event.PINERIDGE_CHANNEL_REMOVED,
    (channel: PineridgeChannel) => {
      setChannels(channels.filter(c => c.pineridgeChannelId !== channel.pineridgeChannelId));
    },
    [channels]
  );

  const handleClickAddChannel = useCallback(() => {
    emitEvent(Event.USER_BEGIN_ADD_PAK_CHANNEL);
  }, []);

  return (
    <>
      <div className="h-auto overflow-auto p-4 space-y-4">
        <DeviceManagementPanel />
        {channels.map(channel => (
          <ChannelPanel channel={channel} key={channel.pineridgeChannelId} />
        ))}
        <div className={`flex justify-center`}>
          <button className={BUTTON_STYLE_MAIN_FLEX} onClick={handleClickAddChannel}>
            <p className="font-bold">Add Channel from Stored PAK</p>
          </button>
        </div>
      </div>
    </>
  );
}
